module.exports = function() {
  return new Worker(__webpack_public_path__ + "9ce065a77789ca4e893c.worker.js");
};